<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }}</label>
    <small v-if="helper" class="form-text form-helper">{{ helper }}</small>
    <select
      :id="id"
      ref="input"
      v-bind="$attrs"
      class="form-control w-100"
      :class="{ error: errors.length }"
      :type="type"
      :value="value"
      @input="$emit('input', $event.target.value)"
    >
      <option v-for="(item, index) in items" :key="index" :value="item.value">
        {{ item.label }}
      </option>
    </select>
    <Error v-if="errors.length" :errors="errors" />
  </div>
</template>

<script>
import Error from '@/Shared/Inputs/Error';

export default {
  inheritAttrs: false,

  components: {
    Error,
  },

  props: {
    id: {
      type: String,
      default() {
        // eslint-disable-next-line no-underscore-dangle
        return `text-input-${this._uid}`;
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    value: String,
    items: Array,
    label: String,
    helper: String,
    errors: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
    select() {
      this.$refs.input.select();
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end);
    },
  },
};
</script>
